<template>
  <div ref="introduction" class="introduction-reference">
    <span class="icon introduction-reference__stethoscope-icon">{{
      $options.stethoscopeIcon
    }}</span>

    <svg
      width="10"
      viewBox="0 0 12 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      class="introduction-reference__hint-border"
    >
      <path d="M 11.4999 0 V 12 H 1.99994 L 11.4999 17.5 V 200" stroke="#201F1D" />
    </svg>

    <div class="introduction-reference__content">
      <div class="introduction-reference__text">
        {{ textContent }}
      </div>
    </div>
  </div>
</template>

<script>
import { ICON, ICON_VALUE } from '@/constants/icons';

export default {
  name: 'IntroductionReference',
  stethoscopeIcon: ICON_VALUE[ICON.STETHOSCOPE],
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    textContent() {
      const text = this.$t(this.content.textKey);

      return text;
    }
  }
};
</script>

<style lang="scss" scoped>
.introduction-reference:lang(ar) {
  direction: rtl;
}
.introduction-reference {
  position: relative;
  display: grid;
  grid-template-columns: 40px 12px auto;
  grid-column-gap: 16px;
  color: var(--u-color-black-6);

  &__content {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    font-style: italic;
    word-break: break-word;
    cursor: pointer;
  }

  &__stethoscope-icon {
    font-family: 'WS Icons', serif;
    min-width: 40px;
    height: 40px;
    font-size: 19px;
    line-height: 40px;
    border-radius: 50%;
    background-color: var(--u-color-grey-100);
    text-align: center;
  }
}

@media (min-width: 600px) {
  .introduction-reference {
    &__hint-border {
      height: 80px;
    }
  }
}

@media (min-width: 960px) {
  .introduction-reference {
    grid-template-columns: 60px 12px auto;

    &__stethoscope-icon {
      min-width: 60px;
      height: 60px;

      font-size: 24px;
      background-color: var(--u-color-white);
      line-height: 60px;
    }
  }
}

@media (min-width: 1440px) {
  .introduction-reference {
    &__stethoscope-icon {
      font-size: 24px;
    }
  }
}
</style>
